import { IMG_1qVX0m87mEqNbsOeancOrs } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabSmokeCo() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'Siren',
      text: t('detail.smoke-co-siren')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.smoke-co-app-notification')
    },
    {
      icon: 'Warning',
      text: t('detail.smoke-co-agent-dispatch')
    },
    {
      icon: 'HeadsetPerson',
      text: t('detail.smoke-co-agent-update')
    },
    {
      icon: 'Ambulance',
      text: t('detail.smoke-co-agent-no-response')
    }
  ] as const
  const disclaimers = [t('disclaimer.sensor-monitoring-plan')] as const
  return (
    <AlarmMomentsTab
      image={IMG_1qVX0m87mEqNbsOeancOrs}
      details={details}
      disclaimers={disclaimers}
    />
  )
}
